'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _mapApi = require('../../shared/mapApi');

require('./FormTextfield.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormTextfield = function (_Component) {
  (0, _inherits3.default)(FormTextfield, _Component);

  function FormTextfield(props) {
    (0, _classCallCheck3.default)(this, FormTextfield);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FormTextfield.__proto__ || (0, _getPrototypeOf2.default)(FormTextfield)).call(this, props));

    _this.submit = (0, _debounce2.default)(_this.props.submitCallback, 200);
    return _this;
  }

  (0, _createClass3.default)(FormTextfield, [{
    key: 'onAutocompleteChange',
    value: function onAutocompleteChange(event) {
      if ((0, _mapApi.isBMap)(this.props.api)) {
        var address = '';
        address += event.item.value.province;
        address += event.item.value.city;
        address += event.item.value.district;
        address += event.item.value.street;
        address += event.item.value.streetNumber;
        address += event.item.value.business;
        this.inputElement.value = address;
      }
      this.submit(this.inputElement.value);
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (this.props.transition) {
        this.inputElement.style.width = this.inputElementWidth + 'px';
        this.inputElement.style.maxWidth = this.inputElementWidth + 'px';
        this.inputElement.style.minWidth = this.inputElementWidth + 'px';
      }
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.props.onChange(this.inputElement.value);
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      if (this.props.transition) {
        this.inputElementWidth = this.inputElement.offsetWidth;
        this.inputElement.style.width = this.inputElementWidth * 1.5 + 'px';
        this.inputElement.style.maxWidth = this.inputElementWidth * 1.5 + 'px';
        this.inputElement.style.minWidth = this.inputElementWidth * 1.5 + 'px';
      }
    }
  }, {
    key: 'onInit',
    value: function onInit(input) {
      if (input && !this.inputElement) {
        this.inputElement = input;
        this.inputElement.required = this.props.required;
        this.inputElement.value = this.props.value;

        if (this.props.autocomplete) {
          this.inputElement.addEventListener('keyup', this.onKeyUp.bind(this));
          if ((0, _mapApi.isGMap)(this.props.api)) {
            this.autocomplete = new this.props.api.places.Autocomplete(this.inputElement);
            // this.autocomplete.setTypes(['address']);
            this.autocomplete.addListener('place_changed', this.onAutocompleteChange.bind(this));
          } else {
            this.autocomplete = new this.props.api.Autocomplete({
              input: this.inputElement
            });
            this.autocomplete.addEventListener('onconfirm', this.onAutocompleteChange.bind(this));
          }
        }
      }
    }
  }, {
    key: 'onKeyUp',
    value: function onKeyUp(event) {
      if (event.keyCode === 13) {
        this.submit(this.inputElement.value);
      }
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      event.preventDefault();
      if (this.inputElement.value.length > 0) {
        this.submit(this.inputElement.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {};
      if (this.props.width) {
        style.width = this.props.width;
        style.maxWidth = this.props.width;
        style.minWidth = this.props.width;
      }

      var addonBeforeAttr = {
        className: 'FormTextfield__addon'
      };
      if (this.props.addonBeforeSubmit) {
        addonBeforeAttr.className += ' FormTextfield__addon--submit';
        addonBeforeAttr.onClick = typeof this.props.addonBeforeSubmit === 'function' ? this.props.addonBeforeSubmit : this.onSubmit.bind(this);
        addonBeforeAttr.tabIndex = '0';
      }

      var addonAfterAttr = {
        className: 'FormTextfield__addon'
      };
      if (this.props.addonAfterSubmit) {
        addonAfterAttr.className += ' FormTextfield__addon--submit';
        addonAfterAttr.onClick = typeof this.props.addonAfterSubmit === 'function' ? this.props.addonAfterSubmit : this.onSubmit.bind(this);
        addonAfterAttr.tabIndex = '0';
      }

      var className = (0, _classname2.default)('FormTextfield', { 'FormTextfield--fullWidth': this.props.fullWidth, 'FormTextfield--inline': this.props.inline }, { 'FormTextfield--uppercase': this.props.uppercase, 'is-required': this.props.required }, { 'has-error': this.props.error });

      return _react2.default.createElement(
        'div',
        { className: className },
        this.props.label && _react2.default.createElement(
          'label',
          { className: 'FormTextfield__label form__label', htmlFor: this.props.name },
          this.props.label,
          this.props.inline && ' :'
        ),
        _react2.default.createElement(
          'div',
          { className: 'FormTextfield__group' },
          _react2.default.createElement(
            'div',
            { className: 'FormTextfield__flex' },
            this.props.addonBefore && _react2.default.createElement(
              'div',
              addonBeforeAttr,
              this.props.addonBefore
            ),
            _react2.default.createElement('input', {
              className: 'FormTextfield__input',
              disabled: this.props.disabled,
              id: this.props.name,
              name: this.props.name,
              onBlur: this.onBlur.bind(this),
              onChange: this.onChange.bind(this),
              onFocus: this.onFocus.bind(this),
              placeholder: this.props.placeholder,
              readOnly: this.props.readOnly,
              ref: this.onInit.bind(this),
              style: style,
              type: 'text',
              value: this.props.value || '',
              'aria-label': this.props.ariaLabel
            }),
            this.props.addonAfter && _react2.default.createElement(
              'div',
              addonAfterAttr,
              this.props.addonAfter
            )
          )
        )
      );
    }
  }]);
  return FormTextfield;
}(_react.Component);

FormTextfield.propTypes = {
  addonAfter: _propTypes2.default.node,
  addonBefore: _propTypes2.default.node,
  addonAfterSubmit: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  addonBeforeSubmit: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  api: _propTypes2.default.object,
  autocomplete: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  submitCallback: _propTypes2.default.func,
  transition: _propTypes2.default.bool,
  width: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  uppercase: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string
};

FormTextfield.defaultProps = {
  addonAfter: null,
  addonBefore: null,
  addonAfterSubmit: false,
  addonBeforeSubmit: false,
  api: null,
  autocomplete: false,
  disabled: false,
  error: false,
  fullWidth: false,
  inline: false,
  label: '',
  name: '',
  onChange: function onChange() {},
  placeholder: '',
  readOnly: false,
  submitCallback: function submitCallback() {},
  transition: false,
  width: null,
  required: false,
  uppercase: false,
  value: '',
  ariaLabel: ''
};

exports.default = FormTextfield;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/FormTextfield/FormTextfield.js
// module id = 127
// module chunks = 0